// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo__Logo__21Vah"};